/**
 * Format amount as Indian Rupee (INR)
 * Uses Indian numbering: 1,00,000 (lakh), 1,00,00,000 (crore)
 */
export const formatINR = (amount) => {
  const num = Number(amount) || 0;
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};
